
import { ComboBox, IComboBoxOption } from "@fluentui/react";
import PoolDropdown from "../../jobManualView/PoolDropdown";
import { withAllFirst, serializePools, POOL_ALL_KEY, type SelectedKey } from "../../../helpers/PoolSelectionHelper";
import FilenameMultiSelectDropdown from "../../jobManualView/FilenameMultiSelectDropdown";
import { FILE_ALL_KEY } from "../../../helpers/FilenameSelectionHelper";
import { JOB_TYPE_LOOKUP } from "../../../../lookup/Consts";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { CREATE_MANUAL_JOB_TITLE, MANUAL_USAGE_MATCHING_JOB_TYPE } from "../../../Consts";
import { JobParameterControlFactory } from "../../../helpers/JobParameterControlFactory";
import { IGenericJobTypeLookupInstance } from "../../../types/IGenericJobTypeLookupInstance";
import { IJobParameterControlBaseDistribution } from "../../../types/JobParameterControls/IJobParameterControlBaseDistribution";
import TextDataInput from "../../../../repertoire/components/textDataInput/TextDataInput";
import React from "react";


import { JOB_CREATED_VIEW } from "../../../../repertoire/Consts";
import { getLookupValues, getOptions } from "../../../helpers/UsageJobFormFieldsHelper";
import ActionButton from "../../../../repertoire/components/actionButton/ActionButton";
import { MessageBanner, MessageType } from "../../../../repertoire/components/messageBanner/MessageBanner";
import SizedDateDataInput from "../../../../repertoire/components/dateDataInput/DateDataInput";
import { DISTRIBUTION_USAGE_FROM_STATE_KEY, DISTRIBUTION_USAGE_TO_STATE_KEY } from "../../../../repertoire/Consts";

const DISTRIBUTION = "USGM_Distribution";
const POOL = "USGM_Pool";
const FILENAME = "USGM_Filename";
const MATCH_TYPE = "USGM_MatchType";
const USAGE_TYPE = "USGM_UsageType";
const SCHEDULE = "USGM_Schedule"
const USAGE_FROM = "USGM_UsageFrom";
const USAGE_TO = "USGM_UsageTo";
const USGM_CONTROL_WRAPPER_CLASS = "form-group col-md-6 col-sm-6 col-xs-12";

const USGMFormFieldsView = ({
    triggerManualJob,
    createNewJob,
    lookups,
    manualJobDataSources,
    getUsageFilenames,
    getScheduledJob,
    upsertScheduledJobAsync,
    scheduledJob,
    getAllUsageFilenamesFromDistribution,
    usageFileNames,
    showModal,
    scheduledJobSet,
    onError
}) => {
    const [jobControls, setJobControls] = React.useState([]);
    const [distributionValue, setDistributionValue] = React.useState('');
    const [poolValue, setPoolValue] = React.useState<SelectedKey[]>([]);
    const [poolOptions, setPoolOptions] = React.useState<IComboBoxOption[]>([]);
    const [filenameValue, setFileNameValue] = React.useState<string[]>([]);
    const [matchTypeValue, setMatchTypeValue] = React.useState('');
    const [usageTypeValue, setUsageTypeValue] = React.useState('');
    const [usageFromValue, setUsageFromValue] = React.useState<string | undefined>(undefined);
    const [usageToValue, setUsageToValue] = React.useState<string | undefined>(undefined);
    const [scheduledValue, setScheduledValue] = React.useState('');
    const [cronError, setCronError] = React.useState('');
    const [isValid, setIsValid] = React.useState(null);
    const [scheduleJobSet, setScheduleJobSet] = React.useState(false);
    const [loading, setLoading] = React.useState(false);


    React.useEffect(() => {
        const jobTypes = getLookupValues(JOB_TYPE_LOOKUP, lookups, MANUAL_USAGE_MATCHING_JOB_TYPE) as IGenericJobTypeLookupInstance;

        if (jobTypes.extraFields.GenericParametersJson && (jobTypes.extraFields.GenericParametersJson != '')) {
            let genericJobBaseParameters = JSON.parse(jobTypes.extraFields.GenericParametersJson) as { controlList: IJobParameterControlBaseDistribution[] }
            let jobControls = JobParameterControlFactory.InstantiateControlList(genericJobBaseParameters.controlList, manualJobDataSources) as IJobParameterControlBaseDistribution[];
            setJobControls(jobControls);
            jobControls.forEach(formItem => {
                if (formItem.ControlID === DISTRIBUTION) {
                    setDistributionValue(formItem.CurrentValue as string)
                }
                if (formItem.ControlID === POOL) {
                    setPoolValue(formItem.CurrentValue ? [...formItem.CurrentValue] : []);
                }
                if (formItem.ControlID === MATCH_TYPE) {
                    setMatchTypeValue(formItem.CurrentValue as string)
                }
                if (formItem.ControlID === FILENAME) {
                    setFileNameValue(formItem.CurrentValue ? String(formItem.CurrentValue).split('|').filter(x => x) : [FILE_ALL_KEY]
                    )
                }
                if (formItem.ControlID === USAGE_TYPE) {
                    setUsageTypeValue(formItem.CurrentValue as string)
                }
            })
        }


    }, []);

    React.useEffect(() => {
        if ((poolValue && distributionValue) && (poolValue.length > 0 && distributionValue !== '')) {
            if (poolValue.includes(POOL_ALL_KEY)) {
                getAllUsageFilenamesFromDistribution(distributionValue)
            }
            else {
                poolValue.forEach(pool => {
                    getUsageFilenames(String(pool), distributionValue);
                });
            }
        }
    }, [distributionValue, poolValue]);

    React.useEffect(() => {
        if (poolValue.length > 0 && distributionValue && matchTypeValue) {
            getScheduledJob(MANUAL_USAGE_MATCHING_JOB_TYPE, JSON.stringify({ controlList: formatparams() }))
        }
    }, [poolValue, distributionValue, matchTypeValue, filenameValue]);

    React.useEffect(() => {
        if (scheduledJob) {
            setScheduledValue(scheduledJob.cronSchedule)
        }
    }, [scheduledJob]);


    React.useEffect(() => {
        if (scheduledValue) {
            setIsValid(isValidCron(scheduledValue));
        }
    }, [scheduledValue]);



    const isValidCron = (cron) => {
        const parts = cron.trim().split(/\s+/);
        if (parts.length !== 5 && parts.length !== 6) return false;

        const validators = [
            { name: 'second', regex: /^(\*|([0-5]?\d)(\/\d+)?|\d+(,\d+)*|\*\/\d+)$/ }, // optional
            { name: 'minute', regex: /^(\*|([0-5]?\d)(\/\d+)?|\d+(,\d+)*|\*\/\d+)$/ },
            { name: 'hour', regex: /^(\*|([01]?\d|2[0-3])(\/\d+)?|\d+(,\d+)*|\*\/\d+)$/ },
            { name: 'dayOfMonth', regex: /^(\*|([1-9]|[12]\d|3[01])(\/\d+)?|\d+(,\d+)*|\*\/\d+)$/ },
            { name: 'month', regex: /^(\*|(1[0-2]|0?[1-9])(\/\d+)?|\d+(,\d+)*|\*\/\d+)$/ },
            { name: 'dayOfWeek', regex: /^(\*|[0-6](\/\d+)?|\d+(,\d+)*|\*\/\d+)$/ }
        ];

        const offset = parts.length === 5 ? 1 : 0;

        return parts.every((part, i) => validators[i + offset].regex.test(part));
    }

    const handleDistributionChange = (option?: IComboBoxOption) => {
        if (!option) return;

        setDistributionValue(option.key as string);

        const poolControl = jobControls.find(c => c.ControlID === POOL);
        let raw = poolControl
            ? ((getOptions(poolControl, option.key as string, true) || []) as IComboBoxOption[])
            : [];

        setPoolOptions(raw);
        setPoolValue([]);
        setFileNameValue([FILE_ALL_KEY]);
        setScheduledValue('');
    }

    const handlePoolChange = (newPools: (string | number)[]) => {
        const allKeys = poolOptions.map(opt => opt.key);

        if (newPools.includes(POOL_ALL_KEY) && newPools.length === 1) {
            newPools = [POOL_ALL_KEY, ...allKeys];
        } 
        else {
            newPools = newPools.filter(p => allKeys.includes(p));
            if (newPools.length === allKeys.length) {
                newPools = [POOL_ALL_KEY, ...newPools];
            }
        }

        setPoolValue(newPools);
        if (newPools.length > (newPools.includes(POOL_ALL_KEY) ? 2 : 1)) {
            setFileNameValue([FILE_ALL_KEY]);
        }
    };

    const handleMatchTypeChange = (value: IComboBoxOption) => {
        setMatchTypeValue(value.key as string)
        setScheduledValue('');
    }

    const handleUsageTypeChange = (value: IComboBoxOption) => {
        setUsageTypeValue(value.key as string)
        setScheduledValue('');
    }

    const handleScheduleChange = (value: string | number | boolean, fieldname: string) => {
        setScheduledValue(value as string);
        setCronError('');

    }

    const handleUsageFromChange = (value: string | boolean | Date, fieldname: string) => {
        setUsageFromValue(value ? value.toString() : undefined);
        setScheduledValue('');
    }

    const handleUsageToChange = (value: string | boolean | Date, fieldname: string) => {
        setUsageToValue(value ? value.toString() : undefined);
        setScheduledValue('');
    }

    const formatparams = () => {
        const controls = jobControls.map(control => {
            if (control.ControlID === DISTRIBUTION) {
                return { ControlID: control.ControlID, CurrentValue: distributionValue }
            }
            if (control.ControlID === POOL) {
                return {
                    ControlID: control.ControlID,
                    CurrentValue: serializePools(poolValue, withAllFirst(poolOptions))
                }
            }
            if (control.ControlID === MATCH_TYPE) {
                return { ControlID: control.ControlID, CurrentValue: matchTypeValue }
            }
            if (control.ControlID === FILENAME) {
                return { ControlID: control.ControlID, CurrentValue: filenameValue.includes(FILE_ALL_KEY) ? "" : filenameValue.join("|")
                }
            }
            if (control.ControlID === USAGE_TYPE) {
                return { ControlID: control.ControlID, CurrentValue: usageTypeValue }
            }
        }).filter(Boolean);

        controls.push(
            { ControlID: USAGE_FROM, CurrentValue: usageFromValue ?? "" },
            { ControlID: USAGE_TO, CurrentValue: usageToValue ?? "" }
        );

        return controls;
    }

    const setParamsAndTriggerManualJob = () => {
        let params = JSON.stringify({ controlList: formatparams() });
        return triggerManualJob({ jobType: MANUAL_USAGE_MATCHING_JOB_TYPE, jobParameters: params });
    }

    const getFormComponents = (jobControls) => {
        return jobControls.map(formItem => {

            if (formItem.Type === 'combobox' && formItem.ControlID === DISTRIBUTION) {
                return (
                    <div key={formItem.ControlID} className={USGM_CONTROL_WRAPPER_CLASS}>
                        <div className="dropdownDataInput">
                            <ComboBox
                                selectedKey={distributionValue}
                                data-testid="USGM_Distribution"
                                label={formItem.Caption}
                                options={getOptions(formItem, distributionValue)}
                                onChange={(e, selectedOption, i, value) => {
                                    if (selectedOption) // Handle when a custom value is typed
                                        handleDistributionChange(selectedOption);
                                }}
                                useComboBoxAsMenuWidth
                                calloutProps={{ calloutMaxHeight: 270 }}
                                autoComplete="on"
                                allowFreeform={true}
                            />
                        </div>
                    </div>
                );
            }

            if (formItem.Type === 'combobox' && formItem.ControlID === POOL) {

                return (
                    <div key={formItem.ControlID} className={USGM_CONTROL_WRAPPER_CLASS}>
                        <div className="dropdownDataInput">
                            <PoolDropdown
                                data-testid="USGM_Pool"
                                label={formItem.Caption}
                                poolOptions={poolOptions}   // raw per-distribution options; PoolDropdown adds “All” + sorts
                                value={poolValue}           // (string | number)[]
                                onChange={handlePoolChange}
                                disabled={!distributionValue}
                            />
                        </div>
                    </div>
                );
            }

            if (formItem.Type === 'combobox' && formItem.ControlID === MATCH_TYPE) {


                return (<div key={formItem.ControlID} className={USGM_CONTROL_WRAPPER_CLASS}>
                    <div className="dropdownDataInput">
                        <ComboBox
                            selectedKey={matchTypeValue}
                            data-testid="USGM_MatchType"
                            label={formItem.Caption}
                            options={getOptions(formItem, distributionValue)}
                            onChange={(e, selectedOption, i, value) => {
                                handleMatchTypeChange(selectedOption);
                            }}
                            useComboBoxAsMenuWidth
                            calloutProps={{ calloutMaxHeight: 270 }}
                        />
                    </div>
                </div>
                );
            }

            if (formItem.Type === 'combobox' && formItem.ControlID === USAGE_TYPE) {


                return (<div key={formItem.ControlID} className={USGM_CONTROL_WRAPPER_CLASS}>
                    <div className="dropdownDataInput">
                        <ComboBox
                            selectedKey={usageTypeValue}
                            data-testid="USGM_UsageType"
                            label={formItem.Caption}
                            options={getOptions(formItem, distributionValue)}
                            onChange={(e, selectedOption, i, value) => {
                                handleUsageTypeChange(selectedOption);
                            }}
                            useComboBoxAsMenuWidth
                            calloutProps={{ calloutMaxHeight: 270 }}
                        />
                    </div>
                </div>
                );
            }

            if (formItem.Type === 'text-input' && formItem.ControlID === FILENAME) {
                const isFilenameDisabled = poolValue.length > (poolValue.includes(POOL_ALL_KEY) ? 2 : 1);

                return (
                    <div key={formItem.ControlID} className={USGM_CONTROL_WRAPPER_CLASS}>
                        <div className="dropdownDataInput">
                            <FilenameMultiSelectDropdown
                                data-testid="USGM_Filename"
                                label={formItem.Caption}
                                fileOptions={distributionValue && poolValue.length > 0 ? (usageFileNames?.data ?? []) : []}
                                value={filenameValue}
                                onChange={(next) => {
                                    setFileNameValue(next);
                                    setScheduledValue('');
                                }}
                                disabled={isFilenameDisabled}
                                enableSearch={true}
                            />
                        </div>
                    </div>
                );
            }
        })
    }

    const setSchedule = async () => {
        setIsValid(isValidCron(scheduledValue));
        let schedule = {
            cronSchedule: scheduledValue,
            errorList: [],
            lastRunDate: null,
            parameters: JSON.stringify({ controlList: formatparams() }),
            type: MANUAL_USAGE_MATCHING_JOB_TYPE
        }
        if (isValid) {
            setCronError('');
            setLoading(true);
            try {
                await upsertScheduledJobAsync(schedule);
                scheduledJobSet?.(true);
                createNewJob();
            } catch (err: any) {
                onError?.(err?.message || err?.toString() || "An error occurred");
            } finally {
                setLoading(false);
            }
        }
        else {
            setCronError('Please enter a valid Schedule expression.');
        }
    }

    const onClick = async () => {
        setLoading(true);
        try {
            scheduledJobSet?.(true);
            createNewJob();
            setParamsAndTriggerManualJob();
        } catch (err: any) {
            onError?.(err?.message || err?.toString() || "An error occurred");
        } finally {
            setLoading(false);
        }
    }

    const isValidJob = () => {
        return (distributionValue && poolValue.length > 0 && matchTypeValue && usageTypeValue)
    }
    const dismissAlert = () => {
        setCronError('');
    };
    return <>
        <div className="row">
            {jobControls && getFormComponents(jobControls)}

            <div className={USGM_CONTROL_WRAPPER_CLASS} data-testid="USGM_UsageDateRange">
                <div className="row">
                    <div className="col-sm-6 col-xs-12 form-group" data-testid={USAGE_FROM}>
                        <SizedDateDataInput
                            value={usageFromValue}
                            fieldName={DISTRIBUTION_USAGE_FROM_STATE_KEY}
                            changeData={handleUsageFromChange}
                            label={"Usage From"}
                            isHidden={false}
                            readOnly={false}
                        />
                    </div>
                    <div className="col-sm-6 col-xs-12 form-group" data-testid={USAGE_TO}>
                        <SizedDateDataInput
                            value={usageToValue}
                            fieldName={DISTRIBUTION_USAGE_TO_STATE_KEY}
                            changeData={handleUsageToChange}
                            label={"Usage To"}
                            isHidden={false}
                            readOnly={false}
                        />
                    </div>
                </div>
            </div>
        </div>
        <div className="row">

            <div className={USGM_CONTROL_WRAPPER_CLASS}>
                <TextDataInput
                    label={"Schedule"}
                    data-testid="USGM_Schedule"
                    fieldName={SCHEDULE}
                    changeData={handleScheduleChange}
                    value={scheduledValue}
                    readOnly={!(isValidJob())}
                    isHidden={false}
                    isMandatory={false}
                />
            </div>
            <div style={{ marginTop: 12 }} className="form-group col-md-2 col-sm-4 col-xs-12">
                <ActionButton buttonText={"Set"} buttonAction={setSchedule} data-testid="Set-action-button" disabled={!(isValidJob()) || loading} />
            </div>

        </div>
        {cronError && cronError !== '' && (
            <div className="alert alert-danger alert-dismissible">
                <span data-testid="ScheduleError">{cronError}</span>
                <button type="button" className="close" aria-label="Close" data-testid="Create Manual Job-action-button" onClick={dismissAlert}>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        )}
        <div className="row">
            <div className="form-group col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <ActionButton buttonText={"Cancel"} buttonAction={createNewJob} className={"button btn-defaultSecondary"}/>
            </div>
            <div className="form-group col-lg-4 col-lg-push-4 col-md-4 col-md-push-4 col-sm-6 col-sm-push-0 col-xs-12 col-xs-push-0">
                <ActionButton buttonText={CREATE_MANUAL_JOB_TITLE} buttonAction={onClick} disabled={!(isValidJob()) || loading} />
            </div>
        </div>
    </>
}

export default USGMFormFieldsView;